import React from 'react';
import { FooterBox } from './styledFooter';


export default function Footer() {
  return (
    <FooterBox>
    </FooterBox>
  )
}